import { useMemo } from 'react'
import { Alert, AlertRootProps, Badge } from '@iveco-ti/iveco-ds'
import { GripVertical } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { PostModel } from '@/common/models/post'

type newsHighlightedOrderProps = {
  news: PostModel | null
  position: number
}

export function NewsOrderCard({ news, position }: newsHighlightedOrderProps) {
  const { t } = useTranslation('panel')

  const IS_NEW = useMemo(() => news?.id === 'new-slider-news', [news])
  const IS_MARKED_TO_REMOVE = useMemo(() => position > 9, [position])
  const ALERT_COLOR: AlertRootProps['color'] = useMemo(() => {
    if (IS_NEW) return 'primary'
    if (IS_MARKED_TO_REMOVE) return 'danger'
    return 'secondary'
  }, [IS_NEW, IS_MARKED_TO_REMOVE])

  return (
    <Alert.Root color={ALERT_COLOR}>
      <Alert.Icon
        data-swapy-handle
        className="cursor-grab self-center group-data group-data-[swapy-dragging]/item:cursor-grabbing animate-bounce-3-times"
        icon={<GripVertical />}
      />

      <Alert.Body className="w-full select-none">
        <Alert.Description className="flex items-center justify-between gap-2">
          <span>
            <span className="font-bold">{position + 1}. </span>
            {news?.title ||
              news?.subTitle ||
              news?.postFile?.content ||
              news?.postExternalUrl}
          </span>

          <div className="flex items-center gap-4">
            {IS_NEW && (
              <Badge.Root size="sm" shape="square" colors="brand">
                {t('news.drawer_create_news.order.badge.new_news')}
              </Badge.Root>
            )}

            {IS_MARKED_TO_REMOVE && (
              <Badge.Root size="sm" shape="square" colors="danger">
                {t('news.drawer_create_news.order.badge.removed_news')}
              </Badge.Root>
            )}
          </div>
        </Alert.Description>
      </Alert.Body>
    </Alert.Root>
  )
}
